// extracted by mini-css-extract-plugin
export default {"FAQsContainer":"FAQsContainer_FAQsContainer__j7hnp","FAQsList":"FAQsContainer_FAQsList__DZt5A"};